import React from 'react';

const ReviewDisplay = ({ htmlContent }) => {
  if (!htmlContent) {
    // Fallback for when htmlContent is null or undefined, 
    // though aiService should provide a basic error HTML page.
    return (
      <div className="p-4 text-center text-gray-500 dark:text-gray-400">
        No review content available to display.
      </div>
    );
  }

  return (
    <iframe
      srcDoc={htmlContent}
      title="AI Review"
      className="w-full h-full border-none"
      style={{ minHeight: '500px' }} // Ensure iframe has enough height
      sandbox="allow-scripts allow-same-origin" // Allow scripts if AI might generate them, and same-origin for potential resource loading from within the HTML
    />
  );
};

export default ReviewDisplay;